<template>
    <v-container class="mt-8 pb-12" style="max-width: 800px;">
        <v-card outlined class="pa-8 text-center">
            <v-icon size="56" color="grey lighten-1">mdi-chart-box-outline</v-icon>
            <h1 class="text-h5 font-weight-bold mt-4 mb-2">Reports are coming soon</h1>
            <p class="grey--text mb-6">
                Company-wide productivity and task reporting will live here. In the meantime, these already
                give you a real breakdown:
            </p>
            <div class="d-flex justify-center flex-wrap" style="gap: 12px;">
                <v-btn outlined color="primary" @click="$router.push('/managers-hub')" v-if="isAdminOrManager">
                    <v-icon left small>mdi-account-tie</v-icon>
                    Manager's Hub
                </v-btn>
                <v-btn outlined color="primary" @click="goToMyKpis">
                    <v-icon left small>mdi-target</v-icon>
                    My KPIs
                </v-btn>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ReportsComponent',
    computed: {
        ...mapGetters({ get_user: 'auth/get_user' }),
        isAdminOrManager() {
            return this.get_user && [1, 2, 11].includes(this.get_user.role_id);
        },
    },
    mounted() {
        document.title = 'DG Tasks - Reports';
    },
    methods: {
        goToMyKpis() {
            if (this.get_user) {
                this.$router.push(`/directory/${this.get_user.id}/kpis`);
            }
        },
    },
};
</script>
